import { apiFetch } from './fetchConfig';

// 백엔드 API를 통한 사업자등록번호 상태 조회
export const checkBusinessStatus = async (businessRegNo) => {
  try {
    const response = await apiFetch.post('/api/business-status', { businessRegNo });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('백엔드 API 오류 응답:', errorText);
      throw new Error(`사업자 등록번호 조회 API 호출 실패: ${response.status} - ${errorText}`);
    }
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error || '알 수 없는 오류가 발생했습니다.');
    }

    return data;
  } catch (error) {
    console.error('사업자등록번호 상태 조회 실패:', error);
    throw error;
  }
};

// 사업자등록번호 상태 조회
export const searchBusinessRegNo = async (searchValue) => {
  try {
    // 사업자등록번호 형식인지 확인
    const cleanSearchValue = removeHyphens(searchValue);

    // 사업자등록번호가 10자리 숫자인 경우만 API 호출
    if (cleanSearchValue.length === 10 && /^\d{10}$/.test(cleanSearchValue)) {
      const response = await checkBusinessStatus(cleanSearchValue);
      if (response && response.success && response.data) {
        return [{
          id: 1,
          businessRegNo: response.data.businessRegNo,
          companyName: response.data.companyName,
          ceoName: response.data.ceoName,
          address: response.data.address,
          businessType: response.data.businessType,
          status: response.data.status,
          taxType: response.data.taxType,
          b_stt_cd: response.data.b_stt_cd,
          isTradeAvailable: response.data.isTradeAvailable,
          rawData: response.data.rawData
        }];
      } else {
        throw new Error('해당 사업자등록번호를 찾을 수 없습니다.');
      }
    } else {
      throw new Error('사업자등록번호는 10자리 숫자여야 합니다.');
    }

  } catch (error) {
    console.error('사업자등록번호 상태조회 실패:', error);
    throw error;
  }
};

// 사업자등록번호 포맷팅 (ex. 123-45-67890 형식으로 포맷)
export const formatBusinessRegNo = (businessRegNo) => {
  if (!businessRegNo) return '';

  const cleanNumber = businessRegNo.replace(/[^0-9]/g, '');

  if (cleanNumber.length === 10) {
    return `${cleanNumber.slice(0, 3)}-${cleanNumber.slice(3, 5)}-${cleanNumber.slice(5)}`;
  }

  return businessRegNo;
};

// 전화번호 포맷팅
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';

  const cleanNumber = phoneNumber.replace(/[^0-9]/g, '');

  if (cleanNumber.length === 11) {
    return `${cleanNumber.slice(0, 3)}-${cleanNumber.slice(3, 7)}-${cleanNumber.slice(7)}`;
  } else if (cleanNumber.length === 10) {
    return `${cleanNumber.slice(0, 3)}-${cleanNumber.slice(3, 6)}-${cleanNumber.slice(6)}`;
  } else if (cleanNumber.length === 9) {
    return `${cleanNumber.slice(0, 2)}-${cleanNumber.slice(2, 5)}-${cleanNumber.slice(5)}`;
  }

  return phoneNumber;
};

// 입력값에서 하이픈 자동 제거
export const removeHyphens = (value) => {
  return value ? value.replace(/-/g, '') : '';
};